// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c344ba52","455":"0038179c","977":"2123d68d"}[chunkId] + ".chunk.js";
};